import { render } from "./StatsSettingsPanel.vue?vue&type=template&id=4e4cfdf2"
import script from "./StatsSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./StatsSettingsPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script